var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Mask",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#0FB700"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2387",
    "data-name": "Group 2387",
    transform: "translate(-1077 -269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    transform: "translate(1077 269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M7.5,0A7.5,7.5,0,1,1,0,7.5,7.5,7.5,0,0,1,7.5,0Z",
    fill: "#0FB700"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cancel-2",
    "data-name": "cancel",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 3.6,
    y2: 4.8,
    transform: "translate(-14.1 10.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x1: 3,
    y2: 9.6,
    transform: "translate(-10.5 5.7)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x2: 3.6,
    y2: 4.8,
    transform: "translate(-14.1 10.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x1: 3,
    y2: 9.6,
    transform: "translate(-10.5 5.7)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M0,3.815,2.9,5.99,5.03,0",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 1081.682, 273.084)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b171a70bb3a9a40efb92d4861dd7a1a0.svg";
export { ForwardRef as ReactComponent };